import * as numeral from "numeral";
import i18next from "../../i18n/i18n";
import moment from "moment";
import data from "currency-codes/data";
import ROUTES from "../../config/Routes";
import {
  CompanyCategory,
  DOMTOMList,
} from './Constants';
import countries from 'i18n-iso-countries';

export const getRandomNumber = () => Math.round(Math.random() * 100);

export const capitalize = (str) =>
  str?.charAt(0)?.toUpperCase() + str?.slice(1);

export const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "EUR":
      return "€";
    case "USD":
      return "$";
    default:
      return currency;
  }
};

export const formatNumber = (number, isDecimal) => {
  const normalized = typeof number === "string" ? number.replace(",", ".") : number;
  return numeral(normalized)
    .format(isDecimal ? "0,0.00" : "0,0")
    .replace(/,/g, " ");
};

export const formatChoices = (arrayOfObjects) => {
  let result = '';
  try {
    for (let i = 0; i < arrayOfObjects.length; i++) {
      result += `Element ${i + 1}:\n`;
      for (const key in arrayOfObjects[i]) {
        let value = arrayOfObjects[i][key];

        if (typeof value === 'string') {
          let formattedValue;

          if (value.includes("<div>") && value.includes("</div>")) {
            formattedValue = value.replace(/<div[^>]*>[\s\S]*?<\/div>/g, ', ').replace(/^, |, $/g, '');
          } else if (value.includes("<br/>") || value.includes("<br>")) {
            formattedValue = value.replace(/<br\/?>/g, ', ').replace(/^, |, $/g, '');
          } else if (value.includes("<div></div>")) {
            formattedValue = value.split("<div></div>").join(', ');
          } else {
            formattedValue = value;
          }
          value = formattedValue;
        }

        // use Localise to translate the key
        result += `  ${window.Localize.translate(key)}: ${value}\n`;
      }
      if (i < arrayOfObjects.length - 1) {
        result += '\n';
      }
    }
  } catch (e) {
    console.error(e);
    result = JSON.stringify(arrayOfObjects);
  }
  return result;
}

export const formatCheckBox = (arrayOfObjects) => {
  let result = [];
  if (arrayOfObjects.includes("<div></div>")) {
    result = arrayOfObjects.split("<div></div>");
  } else if (arrayOfObjects.includes("<br/>")) {
    result = arrayOfObjects.split("<br/>");
  } else {
    result = [arrayOfObjects]
  }

  return result;
}

export function truncate(input) {
  if (input.length > 50) {
    return input.substring(0, 50) + "...";
  }
  return input;
}

export function isEmpty(object) {
  return Object.keys(object).length === 0;
}

export function getDividedCountries(countries) {
  let favoriteCountries = [
    "FR",
    "DE",
    "IT",
    "GB",
    "ES",
    "BE",
    "NL",
    "CH",
    "LU",
    "PT",
    "US",
    "CN",
  ];
  let otherCountries = Object.keys(countries).filter(
    (country) => !favoriteCountries.includes(country)
  );
  return [
    favoriteCountries.map((iso2) => ({ key: iso2, label: countries[iso2] })),
    otherCountries
      .map((iso2) => ({ key: iso2, label: countries[iso2] }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  ];
}

// Retourne tous les pays, filtre en EN sur Taiwan pour retirer le republic of china
export function getCountries(lang) {
  let allCountries = countries.getNames(lang ?? i18next.t('lang'), { select: 'official' })
  if (i18next.language === 'en') {
    allCountries = {...allCountries, TW: "Taiwan"}
  }

  return allCountries;
}

// Retourne le nom d'un pays, filtre en EN sur Taiwan pour retirer le republic of china
export function getCountryName(key, lang) {
  if (lang === 'en' && key === 'TW') {
    return 'Taiwan';
  } else {
    return countries.getName(key, lang);
  }
}

export function formatActivityText(activityType ,activityCode, activityLabel) {
  if (activityLabel && activityCode) {
    return `${activityCode} - ${activityLabel} (${getActivityOriginFromType(activityType, true)
      })`;
  }
  return "";
}

export function formatActivityTextFromActivity(activity) {
  const activityType = getActivityTypeFromOrigin(activity.origine)
  return formatActivityText(activityType, activity.code, activity.description);
}

export function getActivityOriginFromType(activityType, longName = false) {
  if (longName) {
    return activityType?.toUpperCase() === "SIC" ?  "D&B Standard Industry Code" : "NAF"
  } else {
    return activityType?.toUpperCase() === "SIC" ?  "DNB" : "NAF"
  } 
}

export function getActivityTypeFromOrigin(activityOrigin) {
    return activityOrigin === "DNB" ? "SIC": "CODE_APE"
}

export function formatLegalCategory(legalCategoryLabel, legalCategoryCode) {
  return `${legalCategoryLabel || ""} ${legalCategoryCode ? `(${legalCategoryCode})` : ""
    }`;
}

export function formatIssuer(issuer, thirdpartyName, fiscaleMereFille) {
  if (issuer) {
    let issuerLabel = i18next.t(`viewer.issuer.${issuer}`, issuer);
    if (issuer === "FOURNISSEUR") {
      issuerLabel = thirdpartyName;
    } else if (fiscaleMereFille) {
      issuerLabel += ` ${i18next.t("viewer.fiscale_mere_fille")}`;
    }
    return issuerLabel;
  } else {
    return "";
  }
}

export function formatThirdpartyIdentifier(tp, displayDuns = false) {
  if (tp.addressCountryCode?.toUpperCase() === "FR") {
    return `${tp.siret} (Siret)`;
  } else if (displayDuns && tp.duns && !tp.dunsEncrypted){
    return `${tp.duns} (DUNS)`;
  }else {
    const registrationNumbers = tp.listRegistrationNumber?.filter(rn => rn.number !== tp.duns && rn.number !== tp.tva);
    return registrationNumbers?.length > 0 ? `${registrationNumbers[0].number} (${registrationNumbers[0].libelle})` : "";
  }
}

export function formatTurnoverAndCurrency(tp) {
  if (tp.turnover == null || tp.turnoverCurrency == null) {
    return "";
  } else {
    return tp.turnover + " " + tp.turnoverCurrency;
  }
}

export function formatRegistrationStatus(status) {
  switch (status) {
    case "subscribed":
      return "INSCRIT";
    case "without_contact":
      return "SANS CONTACT";
    case "invitation_expired":
      return "INVIATION EXPIREE";
    case "invited":
      return "INVITE";
    case "declined":
      return "DECLINED";
    default:
      return "SANS CONTACT";
  }
}

export function formatIdentifier(tp, countryCode, searchBy, searchByValue) {
  if (tp.source === 'UNMANAGED') {
    return `${tp.localIdValue}`;
  }
  if (searchBy === "DUNS") {
    if (countryCode === "FR") {
      return `${searchByValue} (Duns)`;
    }
    return `${tp.id} (Duns)`;
  }
  if (searchBy === "VAT") {
    return `${tp.vatNumber} (TVA)`;
  }
  if (!tp.isIdEncrypted) {
    return `${tp.id} (${countryCode === "FR" || DOMTOMList.includes(countryCode) ? "Siret" : "Duns"})`;
  } else if (tp.localIdValue !== "0") {
    if (tp.localIdValue) {
      return `${tp.localIdValue} (${tp.localIdType})`;
    } else if (tp.registrationNumbers?.length > 0) {
      return `${tp.registrationNumbers[0].number} (${tp.registrationNumbers[0].libelle})`;
    }
  }
  return "";
}

export function isSiret(value) {
  value = value.trim();
  return !isNaN(value) && value.length === 14 ? true : false;
}

export function isSiren(value) {
  value = value.trim();
  return !isNaN(value) && value.length === 9;
}

export function verifyLuhn(number, size) {
  if (isNaN(number) || number?.length !== size) return false;

  if (number.startsWith("356000000")) {
    return true;
  }

  let bal = 0;
  let total = 0;
  for (let i = size - 1; i >= 0; i--) {
    let step = (number.charCodeAt(i) - 48) * (bal + 1);

    total += step > 9 ? step - 9 : step;
    bal = 1 - bal;
  }
  return total % 10 === 0 ? true : false;
}

export const formatDate = (datetime) => {
  return datetime ? moment(datetime).format(i18next.t("date.dateFormat")) : "";
};

export const formatDataHubDate = (datetime) => {
  if (!datetime) return "";
  const format = i18next.t("date.dateFormat");
  let parsedDate = moment(datetime, format, true);
  if (!parsedDate.isValid()) {
    parsedDate = moment(datetime);
  }
  return parsedDate.isValid() ? parsedDate.format(format) : "";
};

export const formatDateAndTime = (datetime) => {
  return datetime ? moment(datetime).format(i18next.t("date.dateTimeFormat")) : "";
};

export const formatNumberCurrency = (number, currency) => {
  return number
    ? `${formatNumber(number, false)} ${getCurrencySymbol(currency)}`
    : "";
};

export const getViewerUrl = (accountId, document, component, dossierId, thirdpartyId) => {
  let route;
  switch (component) {
    case 'dossier':
      if (thirdpartyId) {
        const tpInitialRoute = document.thirdpartyOnboarded === false || !document.dossierMonitored ? ROUTES.ARCHIVES : ROUTES;
        route = tpInitialRoute.THIRDPARTY_DOSSIER_DOCUMENT_DETAIL
          .replace(":thirdpartyId", thirdpartyId)
          .replace(":dossierId", dossierId)
          .replace(":reponseId", document.reponseId);
      } else {
        const dossierInitialRoute = document.dossierMonitored ? ROUTES : ROUTES.ARCHIVES;
        route = dossierInitialRoute.DOSSIER_DOCUMENT_DETAIL
          .replace(":dossierId", dossierId)
          .replace(":reponseId", document.reponseId);
        route += `?thirdpartyId=${document.thirdpartyId}`
      }
      break;
    case 'documents-list':
      route = ROUTES.DOCUMENT_DETAIL.replace(":reponseId", document.reponseId)
      route += `?thirdpartyId=${document.thirdpartyId}&dossierId=${dossierId}`
      break;
    case 'thirdparty':
      route = ROUTES.THIRDPARTY_DOCUMENT_DETAIL
        .replace(":thirdpartyId", document.thirdpartyId)
        .replace(":reponseId", document.reponseId)
      route += `?dossierId=${dossierId}`
      break;
    default:
      break;
  }
  return `/${accountId}/${route}`;
}

export const hasOption = (accounts, accountId, subscriptionName) => {
  return accounts
    ?.find((x) => x.id === parseInt(accountId))
    ?.subscriptions.some((s) => s?.toLowerCase() === subscriptionName?.toLowerCase());
};

export const hasAnyOption = (accounts, accountId, subscriptionNames) => {
  return subscriptionNames.some((subscriptionName) => hasOption(accounts, accountId, subscriptionName));
};

export const getUserProfile = (user, accountId) => {
  return JSON.parse(user.accounts_roles)?.find(
    (x) => x.id === parseInt(accountId)
  )?.profile;
};

//Math function to calculate quantile, with q is 0.25 for first quartile, for example
export const quantile = (arr, q) => {
  const sorted = arr.sort((a, b) => a - b);
  const pos = (sorted.length - 1) * q;
  const base = Math.floor(pos);
  const rest = pos - base;

  if (sorted[base + 1] !== undefined) {
    return sorted[base] + rest * (sorted[base + 1] - sorted[base]);
  } else {
    return sorted[base];
  }
};

export const setLocalStorageObj = (id, obj) => {
  localStorage.setItem(id, JSON.stringify(obj));
};

export const formatFinancialStrengthRiskLevel = (riskLevel) => {

  if (!riskLevel) return i18next.t(`financialStrength.scoreNotActivated`);

  // We show very high risk level as high
  if (riskLevel === "very_high") riskLevel = "high"

  return i18next.t(`datablocks.financialStrength.severity.${riskLevel}`)
};

export const getCurrencies = () => {
  return data.map(curr => {
    return {
      value: curr.code,
      label: curr.currency
    }
  }).sort((a, b) => a.label.localeCompare(b.label));
}
export const formatEsgScoresValues = (score, noEsgScoring) => {
  if(noEsgScoring) {
    return i18next.t("ESG.noEsgScoring")
  }
  if(!score) {
    return i18next.t("ESG.scoreUnknownLabel");
  }
  return i18next.t("ESG.score" + score + "label");
}
export const formatEsgDepthValues = (depth, noEsgScoring) => {
  if(noEsgScoring) {
    return i18next.t("ESG.noEsgScoring")
  }
  if(!depth) {
    return i18next.t("ESG.scoreUnknownLabel");
  }
  return depth;
}

export const getCompanyCategoryOptions = () => {
  return [
    {
      value: CompanyCategory.PME,
      label: i18next.t(`misc.companyCategoryOptions.${CompanyCategory.PME}`)
    },
    {
      value: CompanyCategory.ETI,
      label: i18next.t(`misc.companyCategoryOptions.${CompanyCategory.ETI}`)
    },
    {
      value: CompanyCategory.GE,
      label: i18next.t(`misc.companyCategoryOptions.${CompanyCategory.GE}`)
    },
    {
      value: CompanyCategory.AUT,
      label: i18next.t(`misc.companyCategoryOptions.${CompanyCategory.AUT}`)
    },
    {
      value: CompanyCategory.NC,
      label: i18next.t(`misc.companyCategoryOptions.${CompanyCategory.NC}`)
    },
  ];
}

// Convertir un alpha hex (00-FF) en pourcentage (0-100)
export const alphaHexToPercent = (alphaHex) => {
  if (!alphaHex || alphaHex.length !== 2) {
    return 100;
  }
  return Math.round((parseInt(alphaHex, 16) / 255) * 100);
};

// Convertir un pourcentage (0-100) en alpha hex (00-FF)
export const percentToAlphaHex = (percent) => {
  const alpha = Math.round((percent / 100) * 255);
  return alpha.toString(16).padStart(2, '0').toUpperCase();
};

// Extraire la couleur et l'alpha depuis la valeur hex (qui peut être #RRGGBB ou #RRGGBBAA)
export const extractHexAndAlpha = (hexString) => {
  if (!hexString) {
    return { color: '000000', alpha: 'FF' };
  }
  const cleanHex = hexString.replace('#', '').toUpperCase();
  if (cleanHex.length === 8) {
    // Format #RRGGBBAA
    return {
      color: cleanHex.substring(0, 6),
      alpha: cleanHex.substring(6, 8),
    };
  } else {
    // Format #RRGGBB
    return {
      color: cleanHex.substring(0, 6),
      alpha: 'FF',
    };
  }
};

// Renvois une couleur hexadecimal plus claire suivant un coefficient
export const lightenHex = (hexColor, coef) => {
  const clean = hexColor.replace('#', '').slice(0, 6);
  const num = parseInt(clean, 16);
  let r = (num >> 16) & 0xff;
  let g = (num >> 8) & 0xff;
  let b = num & 0xff;

  // interpolation vers le blanc
  r = Math.round(r + (255 - r) * coef);
  g = Math.round(g + (255 - g) * coef);
  b = Math.round(b + (255 - b) * coef);

  const toHex = (v) => v.toString(16).padStart(2, '0').toUpperCase();
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

// Renvois une couleur hexadecimal plus sombre suivant un coefficient
export const darkenHex = (hexColor, coef) => {
  const clean = hexColor.replace('#', '').slice(0, 6);
  const num = parseInt(clean, 16);
  let r = (num >> 16) & 0xff;
  let g = (num >> 8) & 0xff;
  let b = num & 0xff;

  // interpolation vers le noir
  r = Math.round(r * (1 - coef));
  g = Math.round(g * (1 - coef));
  b = Math.round(b * (1 - coef));

  const toHex = (v) => v.toString(16).padStart(2, '0').toUpperCase();
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

// Fonction helper pour créer un hex avec alpha (#RRGGBBAA)
export const createHexWithAlpha = (hexColor, opacityPercent) => {
  const cleanHex = hexColor.replace('#', '').substring(0, 6);
  const alphaHex = percentToAlphaHex(opacityPercent);
  return '#' + cleanHex + alphaHex;
};